/* eslint-disable react/prop-types */
/*
 * Copyright (c) 2025. Tooling Team
 */

import Layout from "../components/layout/Layout";
import { RouteDisplay } from "../components/navigation/RouteDisplay";
import { PATHS } from "../utils/constants";
import { Tabs } from "@uhg-abyss/web/ui/Tabs";
import ModernBuildTable from "../components/ModernBuildTable";
import useMedDomainEIS from "../hooks/useMedDomainEIS";
import useLabDomain from "../hooks/useLabDomain";

export function ModernLatestBuilds() {
  return (
    <Layout>
      <div className="grid">
        <RouteDisplay pageRouteDisplay={[PATHS.medDomainEIS]} />
        <Tabs title="Modern Builds">
          <Tabs.Tab label="Med Domain">
            <div className="row mb-4">
              <ModernBuildTable
                useDataHook={useMedDomainEIS}
                title="Med Domain - Latest builds"
                routeDisplay={[PATHS.medDomainEIS]}
                detailsPath={PATHS.medDomainEISDetails.url}
                columnsType="medDomainEIS"
              />
            </div>
          </Tabs.Tab>
          <Tabs.Tab label="Lab Domain">
            <div className="row mb-4">
              <ModernBuildTable
                useDataHook={useLabDomain}
                title="Lab Domain Builds - Latest builds"
                columnsType="labDomain"
                showDiffColumn={false}
                dataKey="labDomainBuildRowData"
              />
            </div>
          </Tabs.Tab>
        </Tabs>
      </div>
    </Layout>
  );
}
